






















import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import {
  diff_match_patch as DiffMatchPatch, Diff, DIFF_DELETE, DIFF_INSERT,
} from 'diff-match-patch';


@Component
export default class DiffDialog extends Vue {
    @Prop({ default: '' })
    leftText!: string;

    @Prop({ default: '' })
    rightText!: string;

    dialog:boolean = false;

    diffs: Diff[] = [];

    differ:DiffMatchPatch = new DiffMatchPatch();

    mounted() {
      this.calculateDiff();
    }

    @Watch('leftText')
    @Watch('righttText')
    calculateDiff() {
      this.diffs = this.differ.diff_main(this.leftText.replace(/[\r\n]{2,}/g, '\n'), this.rightText.replace(/[\r\n]{2,}/g, '\n'));
      this.differ.diff_cleanupSemantic(this.diffs);
    }

    classForDiff = (diffType: number) : string => {
      if (diffType === DIFF_DELETE) {
        return 'del';
      } if (diffType === DIFF_INSERT) {
        return 'ins';
      }
      return '';
    }
}
